import { includes, __ } from 'ramda';
import { combinePath, getDataFieldsNode } from '../dataConnection.utils';
import csomImplementation from './csom';
import jsomImplementation from './jsom';
import getAllQueryFields, { idFilterField } from './sharePointList.filterFields';
import { allChildEls } from 'func-xml';
import buildBaseXml from './sharePointList.base.xml.builder';
import queryListData from './sharePointListAdapter.query';
import restImplementation from './rest';

const $ = (typeof window !== 'undefined') && jQuery;


const LIST_QUERY_MODE_KEY = 'listquerymode';
const LIST_QUERY_MODE_REST = 'rest';
const LIST_QUERY_MODE_CSOM = 'csom';

const VALID_QUERY_MODES = [
    LIST_QUERY_MODE_REST,
    LIST_QUERY_MODE_CSOM,
];

const CLIENT_REST_ERROR =
    'Querying list data by REST is not supported when client-side queries are enabled. Please contact an administrator.';
const invalidQueryModeError = (value) =>
    `Invalid ${LIST_QUERY_MODE_KEY} option: ${value}. Allowed values are ${VALID_QUERY_MODES.join(', ')}`;

const isValidQueryMode = includes(__, VALID_QUERY_MODES);

function updateData(dataSource, newDataFieldsNode) {
    let dom = dataSource.getDom();
    let dataFieldsNode = getDataFieldsNode(dom);

    if (dataFieldsNode) {
        $(dataFieldsNode)
            .empty()
            .append(allChildEls(newDataFieldsNode));
    }
}

const getImplementation = (shpAccess, siteUrl, settings) => {
    const isClient = (shpAccess.type === 'client');
    const queryMode = settings.getOption(LIST_QUERY_MODE_KEY);

    if (queryMode && !isValidQueryMode(queryMode)) {
        throw new Error(invalidQueryModeError(queryMode));
    }

    if (queryMode === LIST_QUERY_MODE_REST) {
        if (isClient) {
            throw new Error(CLIENT_REST_ERROR);
        }

        return restImplementation(siteUrl);
    }

    return isClient
        ? jsomImplementation
        : csomImplementation;
};

function shpListAdapter(definition, template, shpAccess, settings) {
    let listId = definition.listId;
    let listName = "";
    let siteUrl = combinePath(template.getBasePath(), definition.siteURL);

    const { fieldNames, fields, sortBy, sortAsc } = definition;
    const isShpListForm = definition.type === "shpListForm";

    const getListId = () =>
        listName ? "" : listId

    const queryParams = (filterFields) => ({
        siteUrl,
        listId: getListId(),
        listName,
        fields: fieldNames,
        fieldDefinitions: fields,
        filterFields,
        sortBy,
        sortAsc,
    });

    const queryListDataAsync = async (dataSource, filterFields) => {
        const dataXml = await queryListData(
            definition.name,
            getImplementation(shpAccess, siteUrl, settings),
            queryParams(filterFields),
            shpAccess,
            isShpListForm,
            dataSource.getDom(),
        );

        updateData(dataSource, dataXml);
    }

    const executeQueryAsync = (dataSource) => queryListDataAsync(
        dataSource,
        getAllQueryFields(definition, dataSource),
    );

    const initAsync = async (dataSource) => {
        // Set Dom only if its not Main data source
        if (dataSource?.name) {
            dataSource.setDom(buildBaseXml(fields, isShpListForm));
        }
    };

    function setUrlAndListInfo(spSiteUrl, spListId, spListName) {
        siteUrl = spSiteUrl;
        listId = spListId;
        listName = spListName;
    }

    async function queryByIdAsync(dataSource, listItemId) {
        if (Number.isNaN(listItemId)) {
            return null;
        }

        await queryListDataAsync(
            dataSource,
            [idFilterField(listItemId)],
        );
    }

    // interface
    return {
        executeQueryAsync,
        getUrl: () => siteUrl,
        initAsync,
        queryByIdAsync,
        setUrlAndListInfo,
    };
}

export default shpListAdapter;